import classNames from 'classnames'
import {Mention, MentionsInput} from 'react-mentions'
import {HelpIcon} from '../../../icons'
import Error from '../../core/error'
import Tooltip from '../../core/tooltip'
import {replaceVariablesWithExamples} from '../../../utils/text'

const MAX_TEXT_LENGTH = 300

const MentionTextarea = ({
    values,
    errors,
    isPreviewMode,
    isTextareaFocused,
    isDarkMode,
    variables,
    text,
    formFieldText,
    onMentionChange,
    onFocus,
    onBlur,
    isDisabled
}) => (
    <span>
        {!isPreviewMode && (
            <label className={classNames('form-section-label text-label', {dark: isDarkMode})}>
                {text.text}
                <span className="label-divider" />
                <span className="character-count">
                    {values?.text?.plain?.length}/{MAX_TEXT_LENGTH}
                </span>
            </label>
        )}

        <span className="mentions">
            <div
                className={classNames('mentions-wrapper', {
                    focused: isTextareaFocused || values?.text?.plain?.length > 0,
                    dark: isDarkMode,
                    'preview-mode': isPreviewMode
                })}
            >
                <MentionsInput
                    name="text"
                    className={classNames('mentions-input', {
                        dark: isDarkMode,
                        'input-in-preview': isPreviewMode,
                        'no-content': isPreviewMode && !values.text.plain
                    })}
                    disabled={isPreviewMode || isDisabled}
                    value={
                        isPreviewMode
                            ? replaceVariablesWithExamples(values.text, variables) || text.no_text_to_preview
                            : values.text.markup
                    }
                    onChange={onMentionChange}
                    markup="{{__id__}}"
                    allowSuggestionsAboveCursor
                    onFocus={onFocus}
                    onBlur={onBlur}
                >
                    <Mention
                        trigger="{{"
                        data={variables.map((variable) => ({
                            id: variable.key,
                            display: variable.label
                        }))}
                        displayTransform={(id) => `{{${id}}}`}
                        appendSpaceOnAdd
                        renderSuggestion={(entry) => (
                            <div key={entry.id}>
                                <span className="suggestion-label">{entry.display}</span>
                                <span className="suggestion-template">{` {{${entry.id}}}`}</span>
                            </div>
                        )}
                    />
                </MentionsInput>

                {!isPreviewMode && (
                    <label className={classNames('mentions-placeholder', {dark: isDarkMode})}>
                        {formFieldText.text.placeholder}
                    </label>
                )}
            </div>

            <Tooltip placement="right" trigger="click" content={formFieldText.text.info}>
                <HelpIcon />
            </Tooltip>
        </span>

        {errors?.text?.plain && <Error error={errors.text.plain} />}
    </span>
)

export default MentionTextarea
